import type { StickerColor } from '@/modules/common/types/sticker-color.type.ts';
import type { ItemsDto } from '@/modules/common/dto/items.dto.ts';
import type { RoutePointTypeDto } from '@/modules/assignment/dto/route-point-type.dto.ts';
import { RoutePointTypeId } from '@/modules/common/enums/route-point-type-id.enum.ts';
import type { RoutePointType } from '@/modules/assignment/types/route-point-type.type.ts';

interface RoutePointTypeInfo {
  title: string;
  color: StickerColor;
}

export class RoutePointTypeAdapter {
  private static readonly MAP: Record<RoutePointTypeId, RoutePointTypeInfo> = {
    [RoutePointTypeId.Assignment]: {
      title: 'assignment.type.assignment',
      color: 'green',
    },
    [RoutePointTypeId.Agreement]: {
      title: 'assignment.type.agreement',
      color: 'blue',
    },
    [RoutePointTypeId.Notification]: {
      title: 'assignment.type.notification',
      color: 'light-blue',
    },
  };

  static map(id: RoutePointTypeId): RoutePointType {
    return {
      id,
      name: RoutePointTypeAdapter.MAP[id].title,
      color: RoutePointTypeAdapter.MAP[id].color,
    };
  }

  static mapList(response: ItemsDto<RoutePointTypeDto>) {
    return response.items.map((item) => RoutePointTypeAdapter.map(item.RPT_ID));
  }
}
